// utils
import { generateRandomCode } from 'app/utils';

function formatEquipmentCallback(equipmentIndication) {
  const { id, equipmentId, quantity, formAddOn } = equipmentIndication;

  return {
    equipmentId,
    quantity,
    formAddOn: {
      ...formAddOn,
      hasError: false,
      equipmentIndicationId: id,
      randomCode: generateRandomCode()
    }
  };
}

export { formatEquipmentCallback };
